<div class="group">
    <div class="label" [ngClass]="classLabel">{{ label }}</div>
    <div class="counter" *ngIf="counter >= 0" [ngClass]="classCounter">{{ counter }}</div>
</div>
